import CryptoJS from 'crypto-js';

class Secure {

    // Return a hash sha256 from cleartext
    digest = digestString

    encriptApiRequest = (apiRequest: string, cipherKey: string) => {
        let wordArray = createWordArray(digestString(cipherKey))
        let srcs = CryptoJS.enc.Utf8.parse(apiRequest);
        let encrypted = CryptoJS.AES.encrypt(srcs, wordArray, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
        return encrypted.toString();
    }

    decriptApiRequest = (apiResponse: string, cipherKey: string) => {
        let wordArray = createWordArray(digestString(cipherKey))
        let information = CryptoJS.AES.decrypt(apiResponse, wordArray, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
        return information.toString(CryptoJS.enc.Utf8);
    }

    generateCipherKey = (dateTime: string, uuid: string, geoLocation: string) => {
        let base = dateTime + uuid + geoLocation
        base = base.split('').reverse().join('')
        base = this.digest(base)
        return base.substring(base.length - 32)
    }

    getSaltMdlw = (basePass: string, dateString = '') => {
        let mainDate = dateString.split(' ')[0]
        let numberDate = Number(mainDate.split('-').join(''))
        let splitData = Array.from(basePass)
        let startChar = splitData[0].charCodeAt(0)
        let middleChar = splitData[splitData.length / 2].charCodeAt(0)
        let lastChar = splitData[splitData.length - 1].charCodeAt(0)
        let saltNumber = emulateJavaInt(numberDate * startChar);
        saltNumber = emulateJavaInt(saltNumber * middleChar);
        saltNumber = emulateJavaInt(saltNumber * lastChar);
        let baseSaltStr = Array.from(String(saltNumber));
        let reversePass = basePass.split('').reverse()
        let finalData = ''
        for (let i = 0; i < baseSaltStr.length; i++) {
            finalData += baseSaltStr[i]
            finalData += reversePass[i]
        }
        return finalData
    }

    encriptFile = (fileRequestBuffer: unknown) => {
        let wordArray = createWordArray(digestString(process.env.REACT_APP_CYPHER || ''))
        let srcs = CryptoJS.lib.WordArray.create(fileRequestBuffer as number[]);
        let encrypted = CryptoJS.AES.encrypt(srcs, wordArray, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
        return new Blob([cryptJsWordArrayToUint8Array(encrypted.ciphertext)]);
    }

    decriptFile = (fileResponse:  unknown) => {
        let wordArray = createWordArray(digestString(process.env.REACT_APP_CYPHER || ''))
        let information = CryptoJS.AES.decrypt({ciphertext: CryptoJS.lib.WordArray.create(fileResponse as number[])} as CryptoJS.lib.CipherParams, wordArray, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
        return new Blob([cryptJsWordArrayToUint8Array(information)]);
    }

}

function digestString(clearText: string) {
    return CryptoJS.SHA256(clearText).toString(CryptoJS.enc.Hex);
}

function createWordArray(keyString: string) {
    let wordArray: number[] = [];
    const lengthArray = 16
    let utf8Encode = new TextEncoder();
    let data: any = utf8Encode.encode(keyString)
    //the backend fill the key's array to 16 positions
    if (data.length < lengthArray) {
        data = [...data, ...Array(lengthArray - data.length).fill(0)]
    }
    if (data.length > lengthArray) {
        data = data.slice(0, lengthArray)
    }
    //manually get the word, replacing normal CryptoJS.enc.Utf8.parse
    for (let i = 0; i < data.length; i++) {
        wordArray[(i / 4) | 0] |= data[i] << (24 - 8 * i);
    }
    return CryptoJS.lib.WordArray.create(wordArray, data.length);
}

/* Converts a cryptjs WordArray to native Uint8Array */
function cryptJsWordArrayToUint8Array(wordArray: CryptoJS.lib.WordArray) {
    const l = wordArray.sigBytes;
    const words = wordArray.words;
    const result = new Uint8Array(l);
    var i = 0 /*dst*/, j = 0 /*src*/;
    while (true) {
        // here i is a multiple of 4
        if (i == l)
            break;
        var w = words[j++];
        result[i++] = (w & 0xff000000) >>> 24;
        if (i == l)
            break;
        result[i++] = (w & 0x00ff0000) >>> 16;
        if (i == l)
            break;
        result[i++] = (w & 0x0000ff00) >>> 8;
        if (i == l)
            break;
        result[i++] = (w & 0x000000ff);
    }
    return result;
}
export const emulateJavaInt = (value = 0) => {
    const MAX_JAVA_INT_VAL = 2147483647
    const MIN_JAVA_INT_VAL = -2147483648
    switch (true) {
        case value > MAX_JAVA_INT_VAL:
            return overflowJavaInt(value)
        case value < MIN_JAVA_INT_VAL:
            return overflowJavaInt(value * -1) * -1
        default:
            return value
    }
}

export const overflowJavaInt = (data = 0) => {
    let binary32 = (data >>> 0).toString(2);
    let dataVal = Array.from(binary32.substring(binary32.length - 32))
    if (dataVal.length < 32) {
        return parseInt(dataVal.join(''), 2)
    }
    let numberSign = dataVal.shift()
    let firstOneFound = false
    for (let i = dataVal.length - 1; i >= 0; i--) {
        if (firstOneFound) {
            dataVal[i] = dataVal[i] === '1' ? '0' : '1'
        } else {
            firstOneFound = dataVal[i] === '1'
        }
    }
    let finalValue = parseInt(dataVal.join(''), 2)
    return finalValue * (numberSign === '1' ? -1 : 1)
}


export default new Secure();
